/**
 * Pure transcript post-processing for the whisper engine. Separated from
 * whisper.ts so it's unit-testable without touching worker/audio machinery.
 */

/** Bracketed stage directions and music glyphs — classic whisper filler. */
export function stripHallucinations(raw: string): string {
  return raw
    .replace(/\([^)]*\)|\[[^\]]*\]|♪+/g, " ")
    .replace(/\s+/g, " ")
    .trim();
}

/**
 * Collapse whisper's decoder repetition loop: tiny models sometimes emit the
 * same sentence 2-4× for one utterance ("Where can I buy these?" ×3, bench
 * 2026-07-23). Conservative: only drops a sentence when it normalizes to
 * exactly the same text as the sentence right before it.
 */
export function collapseRepeatedPhrases(text: string): string {
  const norm = (s: string): string =>
    s.toLowerCase().replace(/[^\p{L}\p{N}]+/gu, " ").trim();
  const parts = text.split(/(?<=[.?!…])\s+/).filter((p) => p.trim().length > 0);
  if (parts.length < 2) return text;
  const out: string[] = [];
  for (const p of parts) {
    const prev = out.length > 0 ? norm(out[out.length - 1]!) : null;
    const cur = norm(p);
    if (cur.length > 0 && cur === prev) continue;
    out.push(p.trim());
  }
  return out.join(" ");
}
